<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-11">

            </div>
            <div class="col-md-1">
                <a class="nav-link" href="javascript:void(0)" id="navbarDropdownMenuLinkaccount" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="material-icons">person</i>
                    <p>
                        <span class="d-lg-none d-md-block">Account</span>
                    </p>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLinkaccount">
                    <a class="dropdown-item" href="javascript:void(0)">change password</a>
                    <a class="dropdown-item" href="javascript:void(0)">log out</a>
                </div>
            </div>
        </div>
        <div class="col-md-12 card">

            <div class="row">
                <mat-accordion>

                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                is there a procedures for dealing with fecal, vomitus or even blood contamination of
                                pool water?
                            </mat-panel-title>
                            <mat-panel-description>
                                nc
                            </mat-panel-description>
                            <mat-panel-description>
                                12/3/2019
                            </mat-panel-description>
                            <mat-panel-description>
                                infra
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-list role="list">
                            <mat-list-item role="listitem">choices 1</mat-list-item>
                            <mat-list-item role="listitem">choices 2</mat-list-item>
                            <mat-list-item role="listitem">choices 3</mat-list-item>
                        </mat-list>
                        <p>comments</p>
                        <div class="row">
                            <div class="col-md-2">
                                <img src="../../assets/img/logo.png" class="img-thumbnail" />
                            </div>

                            <div class="col-md-2">
                                <img src="../../assets/img/logo.png" class="img-thumbnail" />

                            </div>
                            <div class="col-md-2">
                                <img src="../../assets/img/logo.png" class="img-thumbnail" />

                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Comment">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <div class="file btn btn-lg btn-primary">

                                    <input type="file" />

                                </div>
                            </div>
                            <button mat-raised-button type="submit" class="btn primary">Add</button>

                        </div>
                        </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</div>